import { type DocumentNode, gql } from '@apollo/client';

const fieldMapsConfigQuery: DocumentNode = gql`
  query field_map_config($name: String!) {
    fieldMapConfig(name: $name) {
      id
      name
      mapping {
        externalFieldId
        fieldDefId
      }
      actionSet {
        totalCount
        edges {
          node {
            metadata
          }
        }
      }
      fieldmapSet {
        edges {
          node {
            id
            externalFieldId
            fieldDefinition {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export default fieldMapsConfigQuery;
